// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
    fn_layout_main();
    fn_layout_header();
    fn_comp_visual();
    fn_comp_people();
    fn_comp_map();
    fn_comp_compare();
    fn_comp_featuring();
    fn_comp_catalog();
    fn_comp_reference();
    fn_part_offers();
    fn_part_carousel();
    fn_part_dialog();
    fn_comp_catalog_detail();
});

// --- MISC --- //
$(function () {
    fn_cookie();
    fn_wsw();
    fn_seo_footer();
});